<footer class="ui-doc-footer">
  <div class="ui-doc-footer__left">
    <button
      *ngIf="destructiveAction && destructiveAction.visible !== false"
      type="button"
      class="ui-doc-footer__btn ui-doc-footer__btn--danger"
      [disabled]="destructiveAction.disabled"
      (click)="onAction(destructiveAction.id)">
      <mat-icon *ngIf="destructiveAction.icon">{{ destructiveAction.icon }}</mat-icon>
      {{ destructiveAction.label }}
    </button>
  </div>

  <div class="ui-doc-footer__right">
    <button
      *ngFor="let action of visiblePrimaryActions; trackBy: trackByActionId"
      type="button"
      class="ui-doc-footer__btn"
      [ngClass]="'ui-doc-footer__btn--' + (action.variant || 'primary')"
      [disabled]="action.disabled"
      (click)="onAction(action.id)">
      <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
      {{ action.label }}
    </button>

    <button
      *ngFor="let action of visibleSecondaryActions; trackBy: trackByActionId"
      type="button"
      class="ui-doc-footer__btn"
      [ngClass]="'ui-doc-footer__btn--' + (action.variant || 'outline')"
      [disabled]="action.disabled"
      (click)="onAction(action.id)">
      <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
      {{ action.label }}
    </button>

    <div class="ui-doc-footer__overflow" *ngIf="visibleOverflowActions.length > 0">
      <button
        type="button"
        class="ui-doc-footer__btn ui-doc-footer__btn--outline"
        (click)="toggleOverflowMenu($event)"
        aria-label="More actions"
        [attr.aria-expanded]="overflowMenuOpen">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <div
        class="ui-doc-footer__overflow-menu"
        *ngIf="overflowMenuOpen"
        (click)="$event.stopPropagation()">
        <button
          type="button"
          class="ui-doc-footer__overflow-item"
          *ngFor="let action of visibleOverflowActions; trackBy: trackByActionId"
          [disabled]="action.disabled"
          (click)="onOverflowAction(action.id, $event)">
          <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
          <span>{{ action.label }}</span>
        </button>
      </div>
    </div>
  </div>
</footer>
